module.exports = "<footer class=\"CIDPfooter\">\n  Copyright &copy; CIDP Brasil {{year}}\n</footer>\n"